module.exports = __webpack_public_path__ + "img/notattached.c93e5d21.svg";